import { render, staticRenderFns } from "./gerenXx.vue?vue&type=template&id=a72f01b0&scoped=true"
import script from "./gerenXx.vue?vue&type=script&lang=js"
export * from "./gerenXx.vue?vue&type=script&lang=js"
import style0 from "./gerenXx.vue?vue&type=style&index=0&id=a72f01b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72f01b0",
  null
  
)

export default component.exports